import React from 'react';
import { Hero } from '../components/Hero';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { MoodSelector } from '../components/MoodSelector';
import { CareerSection } from '../components/CareerSection';
import { TravelSection } from '../components/TravelSection';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="bg-zen-bg min-h-screen text-zen-text selection:bg-zen-accent selection:text-white" data-id="element-148">
      <Navbar data-id="element-149" />
      <main data-id="element-150">
        <Hero data-id="element-151" />
        <FeaturesGrid data-id="element-152" />
        <MoodSelector data-id="element-153" />
        <CareerSection data-id="element-154" />
        <TravelSection data-id="element-155" />
      </main>
      <Footer data-id="element-156" />
    </div>;
}